/**
 * How a refused write is reported (1.J deliverable 1): a 401 ends the session the way the shell's
 * query cache does, anything else becomes the fixed notice of its error code.
 */
import { ApiError } from '@codex/contracts';
import { loginRedirectUrl } from '../auth/require-session.js';
import { forgetMe, isSigningOut } from '../shell/session.js';
import { noticeFor } from './messages.js';
import { codeOf } from './model.js';

/** True when `error` was a 401 and the page is going to the login page. */
export function endSessionOn401(error: unknown): boolean {
  if (!(error instanceof ApiError && error.status === 401) || isSigningOut()) return false;
  forgetMe();
  window.location.assign(loginRedirectUrl(window.location.pathname));
  return true;
}

/** Reports `error` through `notify` (nothing for a 401) and returns its code. */
export function reportFailure(notify: (text: string) => void, error: unknown): string {
  const code = codeOf(error);
  if (!endSessionOn401(error)) notify(noticeFor(code));
  return code;
}
